import { useEffect, useRef, useState } from "react";
import { QuePreview } from "./QuePreview";
import { QueProps } from "./QueProps";
import CmsService from "../../../service/CmsService";
import { Card } from "primereact/card";
import { Panel } from "primereact/panel";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Divider } from "primereact/divider";
import { Messages } from "primereact/messages";
import { useTranslation } from "react-i18next";

export function QueReview(){
    const {t}=useTranslation();
    let {id} = useParams();    
    const navigate = useNavigate();
    const location = useLocation();
    const wrk = location.state; // passed by navigate

    const [que,setQue]=useState(null);
    const [message,setMessage]=useState('');
    const [sent,setSent]=useState(false);
    const msgs = useRef(null);

    const questionIcons=()=>{
        var tbContent=[];
        if(que)
        {
            if(que.locked)
                tbContent.push(<i className="pi pi-lock"></i>);
            else
                tbContent.push(<i className="pi pi-lock-open"/>);
            if(que.approved)
                tbContent.push(<i className="pi pi-check"></i>);
        }
        return( 
            <div className='flex gap-2'>
            {tbContent}
            </div>
        )
    }    
    const getReviewType=()=>{
        if(wrk == undefined)
            return "COMMENT";
        if(wrk.workType == 'QUE_APP_ADD'||'QUE_APP_UP')
            return "APPROVE";
        return "REVIEW";
    }
    const send=(status)=>{
        var rev={wrkId:wrk!=undefined?wrk.id:null,
            objId:id,message:message,
            reviewType:getReviewType(),
            status:status};
        CmsService.reviewQuestion(id,rev).then((ret)=>{
            setSent(true);
            if (msgs.current) {
                msgs.current.clear();
                msgs.current.show([
                    { sticky: true, severity: 'success', summary: 'Success', detail: 'Review message is sent', closable:true }
                ]);
            }
        });
    }
    const backToWorklist=()=>{
        navigate('/wrks');
    }
    const reviewHeaderTemplate=()=>{
        return(
            <div className="flex justify-content-between flex-wrap p-toolbar">
                <div className="flex gap-4">
                    <span className="p-panel">Message</span>
                    <Divider layout="vertical" />
                    <Button size="small" severity="secondary" icon="pi pi-arrow-left" onClick={()=>backToWorklist()} 
                        tooltip={t('Back_to_work_list')}></Button>             
                </div>
                <div className="flex gap-4">
                    {wrk!=undefined?
                        <>
                        <Button size="small" severity="success" icon="pi pi-thumbs-up" label={t('Approve')} 
                            onClick={()=>send('APPROVE')} style={{width:'100px'}} 
                            disabled={sent?'disabled':''}>
                        </Button>             
                        <Button size="small" severity="danger" icon="pi pi-thumbs-down" label={t('Reject')}
                            onClick={()=>send('REJECT')} style={{width:'100px'}}
                            disabled={sent?'disabled':''}>
                        </Button>
                        </>:<Button size="small" severity="success" icon="pi pi-send" label={t('Send')} 
                            onClick={()=>send('COMMENT')} style={{width:'100px'}} 
                            disabled={sent?'disabled':''}>
                        </Button>             
                    }
                </div>
            </div>
        )        
    }
    const previewPanelHeader=()=>{
        return(
            <div className="flex justify-content-between flex-wrap p-toolbar">
                <div className="flex gap-4">
                    <label>{t('Question')+': '+id}</label>
                    <div>{questionIcons()}</div>
                    {que.parentId!=undefined?<label>{t('Question_Group')+': '+que.groupName}</label>:''}
                </div>
            </div>
        );
    }  
    const load=()=>{
        CmsService.getQuestion(id).then((ret)=>{
            setQue(ret);
        });
    }
    const getPrompt=()=>{
        if(wrk!=undefined)
            return wrk.workType;
        return t('Write_a_comment_for_the_question');
    }
    const getTitle=()=>{
        if(wrk!=undefined)
            return t('Question_Review');
        return t('Question_Comment');
    }
    useEffect(()=>{
        load();
    },[id]);
    return (
        <div className="col-12 xl:col-8">
            <Card title={getTitle} subTitle={getPrompt}>
                {que?
                <>
                <Messages ref={msgs} />
                <Panel className="col-12 flex flex-column" header={t('Review')} headerTemplate={reviewHeaderTemplate}>
                    <InputTextarea disabled={sent?'disabled':''} autoResize value={message} onChange={(e) => setMessage(e.target.value)} rows={5} cols={30} 
                        className="w-full" placeholder={t('Write_message_here')}/>
                </Panel>
                <Panel className="col-12 flex flex-column" header={''} headerTemplate={previewPanelHeader}>
                    <QueProps question={que}/>
                    <QuePreview id={id}/>
                </Panel>                
                </>:<></>
                }
            </Card>
        </div>
    )
}